import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { PageHeader } from '../components/PageHeader.js';
import { Alert } from '../ui/Alert.js';

export function NotFoundPage(): ReactNode {
  return (
    <div className="page">
      <PageHeader title="No such page" />
      <Alert tone="warning">
        That address is not part of the console. <Link to="/">Back to the overview</Link>.
      </Alert>
    </div>
  );
}
